import { render, staticRenderFns } from "./DownloadForm.vue?vue&type=template&id=2706b49c&scoped=true&"
import script from "./DownloadForm.vue?vue&type=script&lang=js&"
export * from "./DownloadForm.vue?vue&type=script&lang=js&"
import style0 from "./DownloadForm.vue?vue&type=style&index=0&id=2706b49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2706b49c",
  null
  
)

export default component.exports